import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top
 * whenever the pathname in the URL changes.
 *
 * Note: Uses instant scroll (not smooth) for iOS Safari compatibility.
 * Smooth scrolling on iOS can interfere with route transitions.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant scroll for reliable cross-browser behavior (especially iOS Safari)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop; 